import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SearchList, SearchListType } from 'core/components';
import { IInputProps } from 'core/components/Input';
import { PartBomDetails } from 'partBoms/components';
import { useGetPartBoms } from 'partBoms/hooks';
import { IGetPartBomsPayload, IPartBom } from 'partBoms/types';

import { PartBomCard } from './PartBomCard';
import { inputStyle } from './style';

interface IProps {
  isOpen?: boolean;
  onClose?: () => void;
  defaultQuery?: string;
  onSearchQuery?: (query?: string) => void;
  partBomSearchPayload?: IGetPartBomsPayload;
  getPartCardButtons?: (part: IPartBom) => JSX.Element[];
  level?: number;
  type?: SearchListType;
}

export const SearchPartBoms = ({
  isOpen,
  onClose,
  defaultQuery = '',
  onSearchQuery,
  partBomSearchPayload = {},
  getPartCardButtons,
  level = 0,
  type = SearchListType.COMPACT,
}: IProps) => {
  const { t } = useTranslation();

  const searchInputProps: IInputProps = useMemo(
    () => ({
      placeholder: t('labelProductSearch'),
      slotProps: { input: { sx: inputStyle } },
    }),
    [t]
  );

  const renderItem = (partBom: IPartBom, onSelectItemClick: (partBom: IPartBom) => void) => (
    <PartBomCard
      partBom={partBom}
      onClick={onSelectItemClick}
      getPartCardButtons={getPartCardButtons}
    />
  );

  const renderDetails = (
    isDetailsOpen: boolean,
    onCloseDetails: () => void,
    selectedItem: IPartBom | null
  ) => {
    return (
      <PartBomDetails isOpen={isDetailsOpen} onClose={onCloseDetails} partBom={selectedItem} />
    );
  };

  return (
    <SearchList<IPartBom>
      isOpen={isOpen}
      onClose={onClose}
      title={t('titleFindAPartBom')}
      defaultQuery={defaultQuery}
      onSearchQuery={onSearchQuery}
      setQueryToRequestPayload={(query: string) => ({ filters: { query } })}
      searchPayload={partBomSearchPayload}
      useGetSearchList={useGetPartBoms}
      renderItem={renderItem}
      renderDetails={renderDetails}
      level={level}
      type={type}
      searchInputProps={searchInputProps}
    />
  );
};
